__turbopack_context__.v({
  "divider": "FullSearchResults-module-scss-module__9XaaEG__divider",
  "root": "FullSearchResults-module-scss-module__9XaaEG__root",
  "sticky": "FullSearchResults-module-scss-module__9XaaEG__sticky",
  "totalFoundLabel": "FullSearchResults-module-scss-module__9XaaEG__totalFoundLabel",
});
